<audio id="notification-sound">
  <source
    type="audio/mp3"
    [src]="'/assets/Blow.mp3'"
  />
</audio>
<router-outlet></router-outlet>
